import BK01 from "../../assets/images/NFT/bkid001.jpeg";
import BK02 from "../../assets/images/NFT/bkid002.jpeg";
import BK03 from "../../assets/images/NFT/bkid003.jpeg";
import BK04 from "../../assets/images/NFT/bkid004.jpeg";
import BK05 from "../../assets/images/NFT/bkid005.jpeg";
import BK06 from "../../assets/images/NFT/bkid006.jpeg";
import BK07 from "../../assets/images/NFT/bkid007.jpeg";
import BK08 from "../../assets/images/NFT/bkid008.jpeg";
import BK09 from "../../assets/images/NFT/bkid009.jpeg";
import BK10 from "../../assets/images/NFT/bkid010.jpeg";

import BK011 from "../../assets/images/NFT/bkid011.png";
import BK012 from "../../assets/images/NFT/bkid012.png";
import BK013 from "../../assets/images/NFT/bkid013.png";
import BK014 from "../../assets/images/NFT/bkid014.png";
import BK015 from "../../assets/images/NFT/bkid015.png";
import BK016 from "../../assets/images/NFT/bkid016.png";
import BK017 from "../../assets/images/NFT/bkid017.png";
import BK018 from "../../assets/images/NFT/bkid018.png";
import BK019 from "../../assets/images/NFT/bkid019.png";
import BK020 from "../../assets/images/NFT/bkid020.png";

const NFTDataOne = [
  {
    index: 0,
    title: 'Hot Pink',
    path: 'https://opensea.io/assets/ethereum/0x495f947276749ce646f68ac8c248420045cb7b5e/15394711830402302930042362243392948616199013128938209027585602451401160523777',
    currentPrice: '1.1 ETH',
    img: BK01,
  },
  {
    index: 1,
    title: 'Grumpy',
    path: 'https://opensea.io/assets/ethereum/0x495f947276749ce646f68ac8c248420045cb7b5e/15394711830402302930042362243392948616199013128938209027585602452500672151553v',
    currentPrice: '1.1 ETH',
    img: BK02,
  },
  {
    index: 2,
    title: 'Neon',
    path: 'https://opensea.io/assets/ethereum/0x495f947276749ce646f68ac8c248420045cb7b5e/15394711830402302930042362243392948616199013128938209027585602453600183779329',
    currentPrice: '1.1 ETH',
    img: BK03,
  },
  {
    index: 3,
    title: 'Minion',
    path: 'https://opensea.io/assets/ethereum/0x495f947276749ce646f68ac8c248420045cb7b5e/15394711830402302930042362243392948616199013128938209027585602454699695407105',
    currentPrice: '1.1 ETH',
    img: BK04,
  },
  {
    index: 4,
    title: '420',
    path: 'https://opensea.io/assets/ethereum/0x495f947276749ce646f68ac8c248420045cb7b5e/15394711830402302930042362243392948616199013128938209027585602455799207034881',
    currentPrice: '1.1 ETH',
    img: BK05,
  },
  {
    index: 5,
    title: 'Blu',
    path: 'https://opensea.io/assets/ethereum/0x495f947276749ce646f68ac8c248420045cb7b5e/15394711830402302930042362243392948616199013128938209027585602456898718662657',
    currentPrice: '1.1 ETH',
    img: BK06,
  },
  {
    index: 6,
    title: 'Gum',
    path: 'https://opensea.io/assets/ethereum/0x495f947276749ce646f68ac8c248420045cb7b5e/15394711830402302930042362243392948616199013128938209027585602457998230290433',
    currentPrice: '1.1 ETH',
    img: BK07,
  },
  {
    index: 7,
    title: 'Violets R. Blue',
    path: 'https://opensea.io/assets/ethereum/0x495f947276749ce646f68ac8c248420045cb7b5e/15394711830402302930042362243392948616199013128938209027585602459097741918209',
    currentPrice: '1.1 ETH',
    img: BK08
  },
  {
    index: 8,
    title: 'Babadook',
    path: 'https://opensea.io/assets/ethereum/0x495f947276749ce646f68ac8c248420045cb7b5e/15394711830402302930042362243392948616199013128938209027585602460197253545985',
    currentPrice: '1.1 ETH',
    img: BK09,
  },
  {
    index: 9,
    title: 'Albino',
    path: 'https://opensea.io/assets/ethereum/0x495f947276749ce646f68ac8c248420045cb7b5e/15394711830402302930042362243392948616199013128938209027585602461296765173761',
    currentPrice: '1.1 ETH',
    img: BK10,
  },




  {
    index: 10,
    title: 'Blue Water',
    path: 'https://opensea.io/assets/ethereum/0x495f947276749ce646f68ac8c248420045cb7b5e/15394711830402302930042362243392948616199013128938209027585602462396276801537',
    currentPrice: '1.1 ETH',
    img: BK011,
  },
  {
    index: 11,
    title: 'Green Light',
    path: 'https://opensea.io/assets/ethereum/0x495f947276749ce646f68ac8c248420045cb7b5e/15394711830402302930042362243392948616199013128938209027585602463495788429313',
    currentPrice: '1.1 ETH',
    img: BK012,
  },
  {
    index: 12,
    title: 'Spoiled',
    path: 'https://opensea.io/assets/ethereum/0x495f947276749ce646f68ac8c248420045cb7b5e/15394711830402302930042362243392948616199013128938209027585602464595300057089',
    currentPrice: '1.1 ETH',
    img: BK013,
  },
  {
    index: 13,
    title: 'Blue Crush',
    path: 'https://opensea.io/assets/ethereum/0x495f947276749ce646f68ac8c248420045cb7b5e/15394711830402302930042362243392948616199013128938209027585602465694811684865',
    currentPrice: '1.1 ETH',
    img: BK014,
  },
  {
    index: 14,
    title: 'Cutie',
    path: 'https://opensea.io/assets/ethereum/0x495f947276749ce646f68ac8c248420045cb7b5e/15394711830402302930042362243392948616199013128938209027585602466794323312641',
    currentPrice: '1.1 ETH',
    img: BK015,
  },
  {
    index: 15,
    title: 'Asphalt',
    path: 'https://opensea.io/assets/ethereum/0x495f947276749ce646f68ac8c248420045cb7b5e/15394711830402302930042362243392948616199013128938209027585602467893834940417',
    currentPrice: '1.1 ETH',
    img: BK016,
  },
  {
    index: 16,
    title: 'Emo',
    path: 'https://opensea.io/assets/ethereum/0x495f947276749ce646f68ac8c248420045cb7b5e/15394711830402302930042362243392948616199013128938209027585602468993346568193',
    currentPrice: '1.1 ETH',
    img: BK017,
  },
  {
    index: 17,
    title: 'Gran Torino',
    path: 'https://opensea.io/assets/ethereum/0x495f947276749ce646f68ac8c248420045cb7b5e/15394711830402302930042362243392948616199013128938209027585602470092858195969',
    currentPrice: '1.1 ETH',
    img: BK018,
  },
  {
    index: 18,
    title: 'Blu Jmin',
    path: 'https://opensea.io/assets/ethereum/0x495f947276749ce646f68ac8c248420045cb7b5e/15394711830402302930042362243392948616199013128938209027585602471192369823745',
    currentPrice: '1.1 ETH',
    img: BK019,
  },
  {
    index: 19,
    title: 'Albino',
    path: 'https://opensea.io/assets/ethereum/0x495f947276749ce646f68ac8c248420045cb7b5e/15394711830402302930042362243392948616199013128938209027585602461296765173761',
    currentPrice: '1.1 ETH',
    img: BK020,
  },
];

export default NFTDataOne;